import * as React from 'react';

export default function FiberManual({ size = 20, color = '#00000052' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 12.6666C6.7 12.6666 5.59722 12.2138 4.69167 11.3083C3.78611 10.4027 3.33334 9.29992 3.33334 7.99992C3.33334 6.69992 3.78611 5.59714 4.69167 4.69159C5.59722 3.78603 6.7 3.33325 8 3.33325C9.3 3.33325 10.4028 3.78603 11.3083 4.69159C12.2139 5.59714 12.6667 6.69992 12.6667 7.99992C12.6667 9.29992 12.2139 10.4027 11.3083 11.3083C10.4028 12.2138 9.3 12.6666 8 12.6666Z"
        fill={color} />
    </svg>

  );
}
